import React from 'react';
import styled from 'styled-components'
import MainNav from './UI/MainNav';



const Section = styled.section`
background-color: #2498f3
width: 100%;
height: 100vh;
fontWeight: 400;
fontSize: 12px;
`

const Main = ()=>{
    return(
        <Section>
            <MainNav/>
        </Section>
    )
};

export {Main};



// WEBPACK FOOTER //
// ./src/components/Main.js